import React from 'react';
const SvgArchiveThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 100 100" width="1em" height="1em" {...props}>
      <path fill="#5C7896" d="M11 3v94h78V24H68V3H11z" />
      <path opacity={0.3} fill="#1B3F63" d="M89 45L68 24h21v21z" />
      <path fill="#769CC2" d="M68 3l21 21H68V3z" />
      <g fill="#FFF">
        <path d="M44 52h11.5c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5H44v-3zM44 70h11.5c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5H44v-3zM44 46h11.5c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5H44v-3zM44 40h11.5c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5H44v-3zM44 64h11.5c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5H44v-3zM44 58h11.5c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5H44v-3zM44 76h11.5c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5H44v-3zM44 82h11.5c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5H44v-3zM41.5 43H53v3H41.5c-.3 0-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5zM41.5 55H53v3H41.5c-.3 0-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5zM41.5 73H53v3H41.5c-.3 0-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5zM41.5 49H53v3H41.5c-.3 0-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5zM41.5 67H53v3H41.5c-.3 0-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5zM41.5 61H53v3H41.5c-.3 0-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5zM41.5 79H53v3H41.5c-.3 0-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5zM41.5 85H53v3H41.5c-.3 0-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5zM44 88h11.5c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5H44v-3zM44 94h11.5c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5H44v-3zM41.5 91H53v3H41.5c-.3 0-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5z" />
      </g>
      <path fill="#5C7896" d="M47 40h3v57h-3V40z" />
      <path opacity={0.7} fill="#5C7896" d="M41 10h15v36H41z" />
      <g fill="#FFF">
        <path d="M46 7h5v10h-5V7z" />
        <path d="M44.8 25h7.5c.4 0 .8.3.8.8v7.5c0 .4-.3.8-.8.8h-7.5c-.4 0-.8-.3-.8-.8v-7.5c0-.5.3-.8.8-.8zM41 10.8V39c0 .6.4 1 1 1h13c.6 0 1-.4 1-1V10.8c0-.4-.3-.8-.8-.8H53v9h-9v-9h-2.2c-.5 0-.8.3-.8.8z" />
      </g>
    </svg>
  );
});
export default SvgArchiveThumbnail;
SvgArchiveThumbnail.iconName = 'archive-thumbnail';
SvgArchiveThumbnail.displayName = 'SvgArchiveThumbnail';
